/**
 * Created by bartdecorte on 27/04/2017.
 */
import Page from '../Page';
import RowDrag from '../../utils/RowDrag';
import Request from '../../utils/Request';
import { modifierState } from '../../helpers/os';
import CloneModuleModal from '../../modals/CloneModuleModal';

class WebsitesShow extends Page {
  constructor() {
    super();

    this.droppableInactiveClass = 'table-group--inactive';
    this.dummyModuleGroupClass = 'table-group--new';
    this.tableGroupClass = 'table-group';
    this.groupTitleClass = 'table-group__title-input';

    this.cloneModuleModal = new CloneModuleModal();

    this.bindListeners();
    this.bindKeys(this.keyBindings());
  }

  bindListeners() {
    const $body = $('body');
    $body
      .on('dragstart', '.js-module-row', (ev) => this.lRowDragStart(ev))
      .on('change', '.' + this.groupTitleClass, (ev) =>
        this.lTableGroupNameChanged(ev)
      )
      .on('click', '.tables tr[data-related="0"]', (ev) => this.lRowClick(ev))
      .on('click', '.js-btn-clone', (ev) => this.lBtnCloneClick(ev))
      .on('click', '.js-btn-clone-to', (ev) => this.lBtnCloneToClick(ev));
  }

  lRowDragStart(ev) {
    let $elt =
      $(ev.target).get(0).tagName === 'TR'
        ? $(ev.target)
        : $(ev.target)
            .parents('tr')
            .first();

    this.showRelatedTablesForBaseTable($elt, false);

    const $tableGroups = this.tableGroups();
    $.makeArray($tableGroups).forEach((t) =>
      this.setTableGroupActive($(t), false)
    );

    const dragEnterCallback = ($tableGroup) =>
      this.setTableGroupActive($tableGroup, true);
    const dragLeaveCallback = ($tableGroup) =>
      this.setTableGroupActive($tableGroup, false);
    const dragEndCallback = () => {
      this.resetTableGroupStates();
      this.showRelatedTablesForBaseTable($elt);
    };
    const dropCallback = (from, to, changes, $droppable) => {
      this.resetTableGroupStates();

      let appendAtIndex = this.indexForGroup(to, $droppable);

      if ($droppable.hasClass(this.dummyModuleGroupClass))
        $droppable = this.createNewModuleGroup();

      const $relatedTables = this.relatedTablesForBaseTable($elt);
      this.showRelatedTablesForBaseTable($elt);
      $elt.detach();

      this.appendDraggableAtIndex($droppable, $elt, appendAtIndex);

      for (let i = 0; i < $relatedTables.length; i++)
        $elt.after($relatedTables[i]);

      this.removeEmptyGroups();

      const newGroupName = $droppable.data('group-name');
      this.updateGroupOfTable(
        $elt.data('table-id'),
        newGroupName,
        appendAtIndex > 0 ? appendAtIndex + 1 : appendAtIndex
      )
        .then(() => this.fetchNewGroupName())
        .then(({ data: { group } }) => {
          this.updateDummyModuleGroupName(group);
        });
    };

    new RowDrag({
      $row: $elt,
      ev: ev,
      $droppable: $tableGroups,
      appendableSelector: 'tbody',
      moveOnDrop: true,
      dragEnterCallback: dragEnterCallback,
      dragLeaveCallback: dragLeaveCallback,
      dragEndCallback: dragEndCallback,
      callback: dropCallback,
      clearSpacers: () => {
        this.clearSpacers();
      },
    });
  }

  lTableGroupNameChanged(ev) {
    const $input = $(ev.target);
    const val = $input.val();
    const $group = $input.parents('.' + this.tableGroupClass).first();
    this.updateTableGroupName($group, val)
      .then(() => {
        $group.attr('data-group-name', val).data('group-name', val);
        this.reSortTableGroups();
      })
      .catch(() => {
        $group.find('.' + this.groupTitleClass).val($group.data('group-name'));
      });
  }

  lRowClick(ev) {
    let cancel = ['a'];
    if (
      $(ev.target).is(cancel.join(', ')) ||
      $(ev.target).parents(cancel.join(', ')).length
    ) {
      return true;
    }

    let $elt =
      $(ev.target).get(0).tagName === 'TR'
        ? $(ev.target)
        : $(ev.target)
            .parents('tr')
            .first();
    const location = $elt
      .find('.btn-show')
      .first()
      .attr('href');

    if (modifierState(ev)) {
      window.open(location, '_blank');
      return false;
    }

    window.location = location;
    return false;
  }

  lBtnCloneClick(ev) {
    return true;
  }

  lBtnCloneToClick(ev) {
    ev.preventDefault();
    const $elt = $(ev.target);
    const tableId = $elt
      .parents('[data-table-id]')
      .first()
      .data('table-id');
    this.cloneModuleModal.setTableId(tableId);
    $('#modal-clone-module').modal('show');
    return false;
  }

  clearSpacers() {
    $('.table-group .spacer').detach();
  }

  tableGroups() {
    return $('.' + this.tableGroupClass);
  }

  tableGroupNames(filter = '*') {
    const $tableGroups = this.tableGroups().filter(filter);
    const groupNames = $.makeArray($tableGroups).map((tableGroup) =>
      $(tableGroup).data('group-name')
    );
    return groupNames;
  }

  setTableGroupActive($tableGroup, isActive = true) {
    if (isActive && $tableGroup.hasClass(this.droppableInactiveClass)) {
      $tableGroup.removeClass(this.droppableInactiveClass);
      return this;
    }

    if (!isActive && !$tableGroup.hasClass(this.droppableInactiveClass))
      $tableGroup.addClass(this.droppableInactiveClass);

    return this;
  }

  resetTableGroupStates() {
    const $tableGroups = this.tableGroups();
    let $tableGroup;
    for (let i = 0; i < $tableGroups.length; i++) {
      $tableGroup = $($tableGroups[i]);

      if (!$tableGroup.hasClass(this.dummyModuleGroupClass)) {
        this.setTableGroupActive($tableGroup, true);
      } else {
        this.setTableGroupActive($tableGroup, false);
      }
    }

    return this;
  }

  dummyModuleGroup() {
    return $('.' + this.dummyModuleGroupClass).first();
  }

  updateDummyModuleGroupName(name) {
    this.dummyModuleGroup()
      .attr('data-group-name', name)
      .data('group-name', name);
    return this;
  }

  createNewModuleGroup() {
    const $new = this.dummyModuleGroup()
      .clone()
      .removeClass(this.dummyModuleGroupClass)
      .attr('data-group-exists', 1)
      .data('group-exists', 1);
    $new
      .find('.' + this.groupTitleClass)
      .val($new.data('group-name'))
      .prop('disabled', false);
    $new.find('thead').removeAttr('style');
    this.setTableGroupActive($new);

    const name = $new.data('group-name');

    const groupNames = this.tableGroupNames('[data-group-exists="1"]').sort();
    groupNames.push(name);
    groupNames.sort();
    const newGroupIndex = groupNames.indexOf(name);
    const $tableGroups = this.tableGroups();
    $($tableGroups[newGroupIndex]).after($new);
    return $new;
  }

  indexForGroupAlpha(index, $droppable, $elt) {
    const $tables = $droppable.find('[draggable]');
    const tableNames = $.makeArray($tables).map((table) =>
      $(table).data('table-name')
    );
    const currentTableName = $elt.data('table-name');
    tableNames.push(currentTableName);
    const unique = [...new Set(tableNames)];
    const sorted = unique.sort();
    return sorted.indexOf(currentTableName);
  }

  indexForGroup(index, $droppable) {
    const allGroupNames = this.tableGroupNames();
    const groupName = $droppable.data('group-name');
    const groupIndex = allGroupNames.indexOf(groupName);
    const precedingGroupNames = allGroupNames.slice(0, groupIndex);
    const allowedAttributes = precedingGroupNames.map(
      (name) => '[data-group-name="' + name + '"]'
    );
    const $precedingGroups = this.tableGroups().filter(
      allowedAttributes.join(',')
    );
    const $precedingTables = $precedingGroups.find('[draggable]');
    const $emptyPrecedingGroups = $precedingGroups.filter(
      (index, group) => $(group).find('[draggable]').length < 1
    );
    return index - $precedingTables.length - $precedingGroups.length;
  }

  appendDraggableAtIndex($droppable, $draggable, index) {
    const $draggables = $droppable.find('[draggable]');

    if ($draggables.length) {
      if (index === 0) {
        $($draggables[0]).before($draggable);
      } else {
        $($draggables[index - 1]).after($draggable);
      }
    } else {
      $droppable.find('tbody').append($draggable);
    }
    return this;
  }

  relatedTablesForBaseTable($table) {
    let related = $([]);
    let $next = $table.next();
    while ($next.data('related') == 1) {
      related = related.add($next);
      $next = $next.next();
    }
    return related;
  }

  showRelatedTablesForBaseTable($table, doShow = true) {
    const relatedTables = this.relatedTablesForBaseTable($table);

    if (relatedTables.length) {
      const $lastTableGroup = this.tableGroups().last();
      const $firstRelatedTable = $(relatedTables[0]);
      $lastTableGroup.css(
        'padding-bottom',
        doShow ? 0 : relatedTables.length * $firstRelatedTable.outerHeight(true)
      );
    }

    for (let i = 0; i < relatedTables.length; i++) {
      let $relatedTable = $(relatedTables[i]);
      if (doShow) {
        $relatedTable.removeAttr('style');
      } else {
        $relatedTable.css('display', 'none');
      }
    }
    return this;
  }

  removeEmptyGroups() {
    const $emptyGroups = this.tableGroups()
      .filter('[data-group-exists="1"]')
      .filter((index, group) => $(group).find('[draggable]').length < 1);
    $emptyGroups.detach();
    return this;
  }

  updateGroupOfTableEndpoint(tableId) {
    return ['websites', esign.info.websiteId, 'tables', tableId].join('/');
  }

  updateGroupOfTable(tableId, group, weight) {
    return this.propagateUpdatedGroupOfTable(tableId, group, weight);
  }

  propagateUpdatedGroupOfTable(tableId, group, weight) {
    const data = { group };
    data.weight = weight + 1;
    const request = new Request(
      this.updateGroupOfTableEndpoint(tableId),
      'PATCH',
      data
    );
    return request.execute();
  }

  newGroupNameEndpoint() {
    return ['websites', esign.info.websiteId, 'new-name'].join('/');
  }

  fetchNewGroupName() {
    const request = new Request(this.newGroupNameEndpoint(), 'GET');
    return request.execute();
  }

  updateTableGroupEndpoint(name) {
    return [
      'websites',
      esign.info.websiteId,
      'table-groups',
      encodeURIComponent(name),
    ].join('/');
  }

  updateTableGroupName($group, newName) {
    this.setTableGroupState($group, 'pending');
    return this.propagateTableGroupName($group.data('group-name'), newName)
      .then((x) => {
        this.setTableGroupState($group, 'success');
      })
      .catch((x) => {
        this.setTableGroupState($group, 'fail');
        throw x;
      });
  }

  propagateTableGroupName(oldName, newName) {
    const data = {
      name: newName,
    };
    const request = new Request(
      this.updateTableGroupEndpoint(oldName),
      'PATCH',
      data
    );
    return request.execute();
  }

  setTableGroupState($group, state) {
    const $container = $group.find('.js-loader-states').first();
    $container
      .find('.js-state.d-flex')
      .removeClass('d-flex')
      .addClass('d-none');
    if (typeof state !== typeof undefined) {
      $container
        .find('.js-state--' + state)
        .removeClass('d-none')
        .addClass('d-flex');
    }

    return this;
  }

  reSortTableGroups() {
    const groupNames = this.tableGroupNames('[data-group-exists="1"]');
    groupNames.sort();

    for (let i = 0; i < groupNames.length; i++) {
      let $group = $('[data-group-name="' + groupNames[i] + '"]');
      let $parent = $group.parent();
      $group.detach();
      $parent.append($group);
    }

    return this;
  }
}

export default WebsitesShow;



// WEBPACK FOOTER //
// ./resources/assets/js/pages/Websites/WebsitesShow.js